module.exports = __webpack_public_path__ + "img/restaurant-food.996df069.svg";